export const PAY_METHODS_GU = {
  1209.2: {
    "code": 1209,
    "template": "webPayment",
    "name": "Banca en Línea",
    "approve": true
  },
  1209: {
    "code": 1209,
    "template": "cash",
    "name": "Agencias",
    "approve": true
  },
  1210: {
    "code": 1210,
    "template": "deposit",
    "name": "Agentes y Corresponsales",
    "approve": false
  },
  1211: {
    "code": 1211,
    "template": "transfer",
    "name": "Transferencia",
    "approve": false
  },
  1410: {
    "code": 1410,
    "template": "deposit",
    "name": "Agencias",
    "approve": false
  },
  1410.2: {
    "code": 1410,
    "template": "deposit",
    "name": "Agentes",
    "approve": false
  },
  1411: {
    "code": 1411,
    "template": "transfer",
    "name": "Transferencia",
    "approve": false
  },
  1212: {
    "code": 1212,
    "template": "deposit",
    "name": "Depósito",
    "approve": false
  },
}

export const BANK_GU_IDS = {
  BAM_PAY_WEB: 1209.2,
  BAM_CASH: 1209,
  BAM_DEPOSIT: 1210,
  BAM_TRANSFER: 1211,
  BI_DEPOSIT: 1410,
  BI_DEPOSIT_B:1410.2,
  BI_TRANSFER: 1411,
  SUPER24_DEPOSIT: 1212
}

export const GU_ORDER_METHODS = {
  BAM: 'bam',
  BI: 'bi',
}
